// extracted by mini-css-extract-plugin
export default {"AsideContainer":"styles_AsideContainer__7QgUe","logo":"styles_logo__VsOt4","linkContainer":"styles_linkContainer__7HoJX","supportContainer":"styles_supportContainer__frruC"};